module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAjCAYAAADbqynIAAAAlUlEQVRYR+2Y0Q2AIAwF6T7Kt/LlGDCNq7mZJmzQpG0qOb7htdyRQJDaxlsWGsKGktvEUHJBRfZzPNmb1PQnmsl/mMuGslvCEIaCCXDkgoGry0lt/VavSryAt1xiObM1DGEomIBsR7+Ca7qW42J1xWsQjiEDiK4RGHLFaxCOIQOIrhG85VzxGoRjyACia8R6hlb7rP8AA0IfnRbdR+QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/menu.png
// module id = 9kyQ
// module chunks = 21